import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import RadioList, { FilterListItem } from '../../RadioList';
import { cameraService } from '../../../../services/central-api/cameras';

function DownloadUserList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, actingBodyId, actingBodyUnitIds }: {
    name: TName;
    actingBodyId: number;
    actingBodyUnitIds: number[];
}) {
    const [search, setSearch] = useState('');
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const minCharactersToSearch = 3;

    useEffect(() => {
        if (search.length < minCharactersToSearch) {
            setItems([]);
            setIsLoading(false);
            return;
        }

        let active = true;
        const timeout = setTimeout(async () => {
            try {
                setIsLoading(true);
                const users = await cameraService.getSimplifiedDownloadUsers(search, actingBodyId, actingBodyUnitIds);
                if (active) {
                    setItems(users.map(user => ({
                        label: user.warName && user.warName !== '' ? user.warName : user.name,
                        value: user.id,
                    })));
                }
            } catch (error) {
                console.error(error);
            } finally {
                if (active) {
                    setIsLoading(false);
                }
            }
        }, 1000);

        return () => {
            active = false;
            clearTimeout(timeout);
        };
    }, [search, actingBodyId, actingBodyUnitIds]);

    return <RadioList
        name={name}
        items={items}
        clearValue={0}
        onSearchTextChange={setSearch}
        isLoading={isLoading}
        minCharactersToSearch={minCharactersToSearch}
    />;
}

DownloadUserList.getCount = (value: number) => value !== 0 ? 1 : 0;

export default DownloadUserList;
